// Whether Study Helper should put the practice tutorial on top by itself.
// Absence of the flag means do not auto-open. A parent-created student never
// has it. The offer also waits until the username, quota, and invite
// surfaces are closed.
export function shouldAutoOpenStudentTutorial ({
  pendingStudentTutorial = false,
  usernameModalOpen = false,
  quotaModalOpen = false,
  invitePanelOpen = false
} = {}) {
  return pendingStudentTutorial === true &&
    usernameModalOpen !== true &&
    quotaModalOpen !== true &&
    invitePanelOpen !== true
}
